module.exports = __webpack_public_path__ + "img/product-atomizer-kangertech-TOGO_mini.88677191.jpg";